import { z } from "zod";
import { authenticationResponseJSONSchema } from "../schemas.js";

export default {
  params: z.object({
    accountId: z.string(),
    name: z.string(),
    bic: z.string(),
    iban: z.string(),
    webAuthnAuthenticationResponse: authenticationResponseJSONSchema,
  }),
  response: z.object({
    success: z.boolean(),
  }),
};
